import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumerRoutingModule } from './consumer-routing.module';
import { ProductsListComponent } from './products-list/products-list.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { MenuComponent } from './menu/menu.component';
import { ContactComponent } from './contact/contact.component';
import { LayoutComponent } from './layout/layout.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { SharedConsumerModule } from './shared/shared.module';
import { WizazReviewsComponent } from './wizaz-reviews/wizaz-reviews.component';
import { WizazRatingComponent } from './wizaz-rating/wizaz-rating.component';
import { ProductRedirectComponent } from './product-redirect/product-redirect.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BuyProductModalComponent } from './products/buy-product-modal/buy-product-modal.component';

@NgModule({
  declarations: [
    ProductsListComponent,
    ProductDetailsComponent,
    MenuComponent,
    ContactComponent,
    LayoutComponent,
    WizazReviewsComponent,
    WizazRatingComponent,
    ProductRedirectComponent,
    BuyProductModalComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TooltipModule.forRoot(),
    SharedConsumerModule,
    ReactiveFormsModule,
    ConsumerRoutingModule
  ],
  entryComponents: [
    BuyProductModalComponent
  ]
})
export class ConsumerModule { }
